document.addEventListener("DOMContentLoaded", function () {
  const videoWrapper = document.querySelector(".sk8z-video");
  const video = videoWrapper.querySelector("video");
  const playBtn = videoWrapper.querySelector(".play-button");

  playBtn.addEventListener("click", function () {
    if (video.paused) {
      video.play();
      playBtn.style.display = "none";
    }
  });
  video.addEventListener("pause", function () {
    playBtn.style.display = "block";
  });
});

$(document).ready(function() {
  $('a[href*="#"]').on('click', function(e) {
    // Only apply if the link is on the same page
    if (this.pathname === window.location.pathname && this.hash !== "") {
      //e.preventDefault();
      var target = $(this.hash);
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 600, 'swing'); // 600ms duration
      }
    }
  });
});

document.querySelectorAll('.menu-drawer__menu li a').forEach(link => {
  link.addEventListener('click', function (e) {
    const details = this.closest('details'); // find parent <details>
    if (details) {
      details.classList.remove('menu-opening');
      details.removeAttribute('open');
      const summary = details.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
      }
    }
  });
});

